import {config} from '../config';

export default {
    getApiUrl: () => config.data.app.apiUrl,
    getReportsApiUrl: () => config.data.app.reportsApiUrl,
    getDataCollectionApiUrl: () => config.data.app.dataCollectionApiUrl,
    getModulesHostApiUrl: () => config.data.app.modulesHostApiUrl,
    getOpenStreetApiUrl: () => config.data.app.openStreetApiUrl,
};
